import axios from 'axios';

import cfac22 from '../cfac22';

export function getCardsByOrgsNode(uId, orgId) {
  return new Promise((resolve, reject) => {
    Promise.resolve()
      .then(() => {
        axios
          .get(cfac22('API_HOST_V2') + `/cards/getCardsByOrgs`, {
            headers: { 'Full-Url': window.location.href },
            params: {
              orgId,
              uId,
            },
            withCredentials: true,
          })
          .then((result) => {
            resolve(result.data.result);
          })
          .catch((error) => {
            return reject(error.data.error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}

